define(
    'viewmodels/secured/explorer/navigation/libraries/List',[
        "durandal/app",
        "viewmodels/controller",
        "services/service.dialog",
        "viewmodels/secured/explorer/context",
        "providers/dataprovider",
        "extensions/kendo.extensions"
    ],
    function(app, shell, dialogService, ctx, dataProvider, kendoExt) {

        function List(listId, listName, library, i19n, accessControlList, isAdmin) {
            var self = this;
            
            self.listId = listId;
            self.listName = listName;
            self.library = library;
            self.folders = ko.observableArray([]),
            self.schema = ko.observable();
            self.accessControlList = accessControlList;
            self.isAdmin = isAdmin;
            self.filters = {
                my: { values: ko.observableArray(), isLoaded: ko.observable(false) },
                //team: { values: ko.observable(), isLoaded: ko.observable(false) },
                all: { values: ko.observableArray(), isLoaded: ko.observable(false) }
            };
            self.active = {
                filter: ko.observable(),
                selectedRow: ko.observable(),
                values: ko.observableArray(),
            };

            //#region i19n
            //self.i19n = {
            //    to: {
            //        showmy_: String.format(i19n.to.showmy_, self.library.name),
            //        showmyteams_: String.format(i19n.to.showmyteams_, self.library.name),
            //        showall_: String.format(i19n.to.showall_, self.library.name)
            //    },
            //    filter: {
            //        myPlaceholder: i19n.to.filterinmy_,
            //        teamPlaceholder: i19n.to.filterinmyteam_,
            //        allPlaceholder: i19n.to.filterinall_
            //    }
            //};
            //self.i19n.to.__placeholder__ = ko.computed(function () {
            //    var activeFilter = self.active.filter();
            //    return activeFilter ? String.format(self.i19n.filter[activeFilter + "Placeholder"], self.library.name) : "";
            //});
            //#endregion           

            self.updatingFollowStatusPromises = ko.observableArray([]);
            self.isBusy = ko.computed(function () {
                return self.updatingFollowStatusPromises().length;
                //return self.isBusyPromises().length > 0;
            });

            self.isShowFollow = ko.observable('my');
            self.showFollow = ko.asyncCommand({
                canExecute: function (isExecuting) {
                    return !isExecuting && (self.isShowFollow() == 'all' ? self.canSwitchFilter('my') : self.canSwitchFilter('all'));
                },
                execute: function (library, event, complete) {
                    if (self.isShowFollow() == 'all') {
                        switchFilter("my", library, complete);

                        self.isShowFollow('my');                        
                    } else if (self.isShowFollow() == 'my') {
                        switchFilter("all", library, complete);

                        self.isShowFollow('all');                        
                    } else {
                        complete();
                    }
                }
            });
            self.updateIsFollowing = function (listValueId, isFollowing) {
                markIsFollowing(listValueId, self.active.values(), isFollowing);

                //if (self.filters.my.isLoaded()) {
                    markIsFollowing(listValueId, self.filters.my.values(), isFollowing);
                //}
                //if (self.filters.all.isLoaded()) {
                    markIsFollowing(listValueId, self.filters.all.values(), isFollowing);
                //}

                var promise = isFollowing ? dataProvider.lists.followListValue(listValueId) : dataProvider.lists.unfollowListValue(listValueId);

                self.updatingFollowStatusPromises.push(promise);                

                promise.always(function () {
                    setTimeout(function () {
                        // remove the promise from the queue now that it has completed - even if errored.
                        var index = self.updatingFollowStatusPromises.indexOf(promise);
                        if (index >= 0) {
                            self.updatingFollowStatusPromises.splice(index, 1);
                        }
                    
                        if (self.updatingFollowStatusPromises().length == 0) {
                            //console.warn(self.updatingFollowStatusPromises().length);
                        }
                    }, 10);
                });

                //return;

                //markIsFollowing(listValueId, self.active.values(), isFollowing);

                //if (self.filters.my.isLoaded()) {
                //    var listValue = _.find(self.active.values(), function (lv) {
                //        return lv.listValueId == listValueId;
                //    });
                //    //updateMyListValues(self.filters.my.values, listValue, isFollowing);
                //    var val = _.find(self.filters.my.values(), function (itm) {
                //        return itm.listValueId == listValue.listValueId;
                //    });

                //    if (!val && isFollowing) {
                //        self.filters.my.values.push(listValue);
                //    } else if (val) {

                //        markIsFollowing(listValue.listValueId, self.filters.my.values(), isFollowing);

                //        var arr = _.where(self.filters.my.values(), { following: true });

                //        self.active.values(arr);
                //    }
                //}
                //if (self.filters.all.isLoaded()) {
                //    markIsFollowing(listValueId, self.filters.all.values(), isFollowing);
                //}

                //var promise = isFollowing ? dataProvider.lists.followListValue(listValueId) : dataProvider.lists.unfollowListValue(listValueId);

                //self.updatingFollowStatusPromises.push(promise);

                //promise.always(function () {
                //    // remove the promise from the queue now that it has completed - even if errored.
                //    var index = self.updatingFollowStatusPromises.indexOf(promise);
                //    if (index >= 0) {
                //        self.updatingFollowStatusPromises.splice(index, 1);
                //    }
                //});
            };
            self.relatedListValues = [];
            self.kendoGridTemp = null;
            self.kendoGridTempData = null;
            self.addItem = ko.asyncCommand({
                canExecute: function (isExecuting) {
                    return !isExecuting;
                },
                execute: function (library, event, complete) {
                    if (!self.kendoGridTempData) {
                        dataProvider.lists
                        .getListResults(self.listId)
                        .done(function (data) {
                            self.kendoGridTempData = data;

                            _loadTempGrid(self.kendoGridTempData, function () {
                                //self.kendoGridTemp.addRow();
                                var row = self.kendoGridTemp.dataSource.add();
                                var $row = self.kendoGridTemp.table.find('tr[data-uid="' + row.uid + '"]');

                                self.kendoGridTemp.select($row);
                                self.kendoGridTemp.editRow($row);
                            });
                        })
                        .fail(function () {
                        })
                        .always(complete);
                    } else {
                        if (self.kendoGridTemp) {
                            //self.kendoGridTemp.addRow();
                            var row = self.kendoGridTemp.dataSource.add();
                            var $row = self.kendoGridTemp.table.find('tr[data-uid="' + row.uid + '"]');

                            self.kendoGridTemp.select($row);
                            self.kendoGridTemp.editRow($row);
                        }

                        complete();
                    }                    
                }
            });
            self.editItem = ko.asyncCommand({
                canExecute: function (isExecuting) {
                    return !isExecuting;
                },
                execute: function (listValueId, event, complete) {                    
                    if (!self.kendoGridTempData) {
                        dataProvider.lists
                        .getListResults(self.listId)
                        .done(function (data) {
                            self.kendoGridTempData = data;

                            _loadTempGrid(self.kendoGridTempData, function () {
                                var $row = getRowById(listValueId);
                                self.kendoGridTemp.select($row);
                                self.kendoGridTemp.editRow($row);
                            });
                        })
                        .fail(function (e) {
                            console.error(e);
                        })
                        .always(complete);
                    } else {
                        if (self.kendoGridTemp) {
                            var $row = getRowById(listValueId);
                            self.kendoGridTemp.select($row);
                            self.kendoGridTemp.editRow($row);
                        }

                        complete();
                    }
                }
            });
            self.deleteItem = ko.asyncCommand({
                canExecute: function (isExecuting) {
                    return !isExecuting;
                },
                execute: function (listValueId, event, complete) {
                    if (!self.kendoGridTempData) {
                        dataProvider.lists
                        .getListResults(self.listId)
                        .done(function (data) {
                            self.kendoGridTempData = data;

                            _loadTempGrid(self.kendoGridTempData, function () {
                                var $row = getRowById(listValueId);
                                //self.kendoGridTemp.select($row);
                                self.kendoGridTemp.removeRow($row);
                            });
                        })
                        .fail(function (e) {
                            console.error(e);
                        })
                        .always(complete);
                    } else {
                        if (self.kendoGridTemp) {
                            var $row = getRowById(listValueId);
                            //self.kendoGridTemp.select($row);
                            self.kendoGridTemp.removeRow($row);
                        }
                        
                        complete();
                    }
                }
            });
            self.refresh = function () {
                _.debounce(function () {
                    require(["services/eventbroker", "services/config"], function (eventBroker, config) {
                        eventBroker.trigger(self, config.events.explorer.navigation.refresh, {});
                    });
                }, 100)();
            };

            //#region tempGrid
            function getRowById(listValueId) {
                var itm = self.kendoGridTemp.dataSource.get(listValueId);
                var $row = self.kendoGridTemp.table.find('tr[data-uid="' + itm.uid + '"]');

                return $row;
            }
            function _loadTempGrid(listResults, complete) {
                var deferreds = [];
                var relatedListsMap = {};

                var columns = _.map(listResults.columns, function (column, index) {
                    if (column.type.toLowerCase() == "foreignkey") {
                        column.field = String.format("relatedListId{0}", index);

                        relatedListsMap[column.field] = column.relatedList;

                        deferreds.push(
                            dataProvider.lists
                            .getListValues(column.relatedList.listId)
                            .done(function (relatedListLookupValues) {
                                column.relatedListLookupValues = relatedListLookupValues;
                                column.editor = getDropDownEditor(self, column.field, column.relatedListLookupValues);
                            })
                        );

                    }
                    return column;
                });

                $.when.apply(self, deferreds).always(function () {

                    columns = kendoExt.grid.addColumnTemplateFormatters(columns);

                    var cmd = [];
                    var schema = { model: { id: "listValueId", fields: {} } };
                    var $domElement = $('<div id="list-grid-temp-' + self.listId + '" style="visibility:hidden"></div>').appendTo(document.body);

                    _.each(columns, function (column) {
                        schema.model.fields[column.field] = {};

                        if (column.type.toLowerCase() !== "foreignkey") {
                            schema.model.fields[column.field].type = column.type;
                            schema.model.fields[column.field].validation = { required: true, "data-required-msg": String.format(i19n.to._isrequired, column.title) };
                        }

                        //if (column.field.toLowerCase() == "code") {
                        //    column.width = 100;
                        //}
                        //if (column.field.toLowerCase() == "description") {
                        //    column.width = "auto";
                        //}
                    });

                    cmd.push({
                        name: "edit",
                        text: i19n.to.edit,
                        click: function (e) {
                            var $row = $(e.target).closest("tr");

                            this.select($row);

                            e.preventDefault();
                            e.stopPropagation();

                            return false;
                        }
                    });
                    cmd.push({ name: "destroy", text: i19n.to.delete });

                    columns.push({
                        command: cmd,
                        title: "",
                        width: cmd.length > 2 ? 300 : 240
                    });

                    var values = _.map(listResults.values, function (value) {
                        var valueMap = { listValueId: value.listValueId };

                        _.each(value.columnValues, function (colValue, index) {
                            var columnDetails = columns[index];

                            if (columnDetails.type.toLowerCase() == "foreignkey") { // if this is the related list values field we need to go get the label description.
                                colValue = _.map(colValue, function (listValueId) {
                                    return { listValueId: listValueId, label: getListValueDescription(columnDetails.relatedListLookupValues, listValueId) };
                                });

                                colValue = _.sortBy(colValue, function (itm) { return itm.label; });
                            }

                            valueMap[columnDetails.field] = colValue;
                        });

                        return valueMap;
                    });

                    self.kendoGridTemp = $domElement.kendoGrid({
                        dataSource: getKendoGridTempDataSource(self.listId, schema, values, relatedListsMap),
                        dataBound: function () {
                            $domElement.hide();
                        },
                        selectable: "row",
                        columns: columns,
                        scrollable: {
                            virtual: true
                        },
                        editable: { mode: "popup", confirmation: false },
                        edit: function (e) {
                            if (e.model.id.length == 0) {
                                $(".k-window-title").text("Add");
                            } else {
                                $(".k-window-title").text("Edit");
                            }
                        }
                    }).data("kendoGrid");

                    complete();
                });
            }
            function getKendoGridTempDataSource(listId, schema, listValues, relatedListsMap) {
                return new kendo.data.DataSource({
                    transport: {
                        read: function (callbacks) {
                            callbacks.success(listValues);
                        },
                        update: function (callbacks) {
                            persistData(callbacks.data, dataProvider.lists.updateListValue)
                            .done(function (result) {
                                //self.notify('success', i19n.to.listitemupdated);
                                
                                self.refresh();

                                callbacks.success();
                            })
                            .fail(function (e) {
                                self.kendoGridTemp.cancelChanges();

                                //result.stopPropagation = true;
                                //self.notify(result.error);

                                console.error(e);

                                callbacks.error(e.error);
                            });
                        },
                        create: function (callbacks) {
                            persistData(callbacks.data, dataProvider.lists.addListValue)
                            .done(function (result) {
                                //self.notify('success', i19n.to.listitemadded);

                                var newItem = { listValueId: result, following: false, Code: callbacks.data.Code, Description: callbacks.data.Description, Label: callbacks.data.Code + "(" + callbacks.data.Description + ")" };
                                ctx.current.listValue = newItem;
                                ctx.current.folder = null;
                                try {
                                    ctx.current.library.list.active.selectedRow(newItem);
                                }
                                catch (ex) { }
                                
                                self.refresh();

                                callbacks.data["listValueId"] = result;
                                callbacks.success(callbacks.data);

                                self.isShowFollow("all");

                                if (self.isShowFollow() == 'all') {
                                    switchFilter("all", self.library, function () {});
                                } else {
                                    switchFilter("my", self.library, function () {});
                                }
                            })
                            .fail(function (e) {
                                self.kendoGridTemp.cancelChanges();

                                //result.stopPropagation = true;
                                //self.notify(result.error);

                                console.error(e);

                                callbacks.error(e.error);
                            })
                            .always(function () {

                            });
                        },
                        destroy: function (callbacks) {
                            var dialogoptions = {ok: {label: 'Yes',message: ''},cancel: {label: 'No',message: ''}};

                            dialogService.showMessageBox(i19n.to.confirmdelete, i19n.to.delete + ' ' + callbacks.data.Code + ' ' + callbacks.data.Description + ' ?', _.toArray(dialogoptions))
                            .then(function (action) {
                                if (action == dialogoptions.cancel) {
                                    self.kendoGridTemp.cancelChanges();
                                }
                                if (action == dialogoptions.ok) {
                                    dataProvider.lists.deleteListValue(listId, callbacks.data.listValueId)
                                    .done(function (result) {
                                        //self.notify('success', i19n.to.listitemdeleted);

                                        ctx.current.listValue = null;
                                        ctx.current.library.list.active.selectedRow(null);
                                        ctx.current.folder = null;

                                        callbacks.success();

                                        self.refresh();                                       
                                    })
                                    .fail(function (e) {
                                        self.kendoGridTemp.cancelChanges();

                                        //result.stopPropagation = true;
                                        //self.notify(result.error);

                                        console.error(e);

                                        callbacks.error(e.error);
                                    });
                                }
                            });
                        },
                    },
                    schema: schema,
                    pageSize: 999
                });

                function persistData(data, updateFn) {
                    var fieldMap = {};
                    var relatedLists = [];

                    _.each(data, function (value, key) {
                        if (key == "listValueId")
                            return;
                        else if (key.indexOf("relatedListId") !== -1) {
                            var listValueIds = _.map(value, function (listValue) {
                                return listValue.listValueId;
                            });

                            relatedLists.push({
                                listId: relatedListsMap[key].listId,
                                listRelationshipId: relatedListsMap[key].listRelationshipId,
                                listValueIds: listValueIds
                            });
                        } else {
                            fieldMap[key] = value;
                        }
                    });

                    return updateFn.call(dataProvider.lists, listId, fieldMap, relatedLists, data.listValueId);
                }
            }
            function getDropDownEditor(self, fieldName, relatedListLookupValues, onChange) {
                return function (container, options) {
                    var currentValues = _.map(options.model[fieldName], function (listValue) {
                        return listValue.listValueId;
                    });

                    $("<select multiple='multiple'>")
                        .appendTo(container)
                        .kendoMultiSelect({
                            dataTextField: "label",
                            dataValueField: "listValueId",
                            value: currentValues || [],
                            dataSource: {
                                transport: {
                                    read: function (callbacks) {
                                        relatedListLookupValues = relatedListLookupValues || [];
                                        relatedListLookupValues = _.sortBy(relatedListLookupValues, function (itm) { return itm.label; });

                                        callbacks.success(relatedListLookupValues);
                                    },
                                }
                            },
                            change: function (e) {
                                var grid = $("#list-grid-temp-" + self.listId).data("kendoGrid");
                                var model = grid.dataItem(grid.select());

                                //if (!model) {
                                //    var row = this.element.closest("tr");
                                //    model = $("#list-values-grid").data("kendoGrid").dataItem(row);
                                //}
                                if (model) {
                                    var uid = model.uid;

                                    items = _.sortBy(this.dataItems(), function (itm) { return itm.label; });

                                    model.set(fieldName, items);

                                    grid.select(grid.tbody.find('tr[data-uid="' + uid + '"]'));
                                }
                            }
                        });
                };
            }
            function getListValueDescription(relatedListLookupValues, listValueId) {
                var relatedListValue = _.find(relatedListLookupValues, function (lookupValue) {
                    return lookupValue.listValueId == listValueId;
                });

                if (!relatedListValue)
                    return null;

                return relatedListValue.label;
            }
            //#endregion
        };
        
        // update the list value isFollowing status in the database and across all filters.
        

        // if the filter is already loaded then we can just switch otherwise we need to make sure the database has received all the "follow/unfollow" requests before allowing them to switch.
        List.prototype.canSwitchFilter = function (filter) {
            var self = this;
            return ko.computed(function () {
                if (self.filters[filter].isLoaded())
                    return true;
                return self.updatingFollowStatusPromises().length == 0;
            });
        };        
        
        List.prototype.accessControl = function (listValueId) {
            this.accessControlList(listValueId);
        };

        return List;

        //#region Internal Methods

        function switchFilter(filter, library, complete) {
            //removeUnfollowedsFromListValues(library.list.filters.my.values);

            library.list.active.filter(filter);

            //if (library.list.filters[filter].isLoaded()) {
            //    library.list.active.values(library.list.filters[filter].values());
            //    complete();
            //    return;
            //}

            library.list.active.values([]);

            shell.isBusy(true);

            ctx.loadListValueForLibrary(library, filter)
            .done(function (data) {
                var q = filter == "my" ? library.list.filters.my.values() : library.list.filters.all.values();

                ctx.onListValueFilter({filter: filter, q: q});
            })
            .always(function () {
                complete();

                shell.isBusy(false);
            });
        }
        function removeUnfollowedsFromListValues(values) {
            values(_.filter(values(), function (lv) {
                return lv.following == true;
            }));
        }

        function markIsFollowing(listValueId, listValues, isFollowing) {
            var val = _.find(listValues, function (itm) {
                return itm.listValueId == listValueId;
            });
            
            if (val) {
                val.following = isFollowing;
            }
        }
        
        //#endregion Internal Methods
    });
